import React, { ReactNode } from "react";

interface DialogActionButtonProps {
  label: ReactNode;
  onClick?: () => void;
  type?: "button" | "submit";
  variant?: "primary" | "secondary" | "danger" | "danger-secondary";
  disabled?: boolean;
  loading?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  className?: string;
}

const VARIANT_CLASS_NAMES = {
  primary:
    "border border-primary bg-primary text-white hover:bg-primary/90 hover:border-primary/90",
  secondary:
    "border border-primary bg-white text-primary hover:bg-[#F3FBFA]",
  danger:
    "border border-[#F24848] bg-[#F24848] text-white hover:bg-[#E23E3E] hover:border-[#E23E3E]",
  "danger-secondary":
    "border border-[#F24848] bg-white text-[#F24848] hover:bg-[#FFF5F5]",
};

const DialogActionButton: React.FC<DialogActionButtonProps> = ({
  label,
  onClick,
  type = "button",
  variant = "primary",
  disabled = false,
  loading = false,
  leftIcon,
  rightIcon,
  className = "",
}) => {
  return (
    <button
      type={type}
      className={`inline-flex min-h-[44px] w-full items-center justify-center gap-2 rounded-[4px] px-5 text-sm font-semibold transition-colors duration-200 ease-out disabled:cursor-not-allowed disabled:opacity-50 ${VARIANT_CLASS_NAMES[variant]} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <span className="flex items-center gap-2">
          <svg
            className="h-4 w-4 animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="3"
              className="opacity-25"
            />
            <path
              d="M22 12a10 10 0 00-10-10"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              className="opacity-90"
            />
          </svg>
          <span>{label}</span>
        </span>
      ) : (
        <>
          {leftIcon ? <span className="shrink-0">{leftIcon}</span> : null}
          <span>{label}</span>
          {rightIcon ? <span className="shrink-0">{rightIcon}</span> : null}
        </>
      )}
    </button>
  );
};

export default DialogActionButton;
